import React from 'react';
import Header from '../components/CommonComponents/Header';
import UserSettings from '../components/UserSettings';

const UserSettingsView = () => {
    return (
        <>
            <Header hideProjectItems={true} />
            <UserSettings />
        </>
    );
};

export default UserSettingsView;
